import {Pipe, PipeTransform} from '@angular/core';
import {AccountState} from 'web-angular-client';
import {AccountStatusUtil} from '../interface/accountStatusUtil';

@Pipe({
    name: 'getAccountStatusDescription',
    standalone: false
})
export class AccountStatusPipe implements PipeTransform
{
    constructor(
        protected accountStatusUtil: AccountStatusUtil)
    {
    }

    /**
     * @return The {@link AccountStatus} of an account that is displayed to the user
     * @param accountState
     */
    transform(accountState: AccountState): string
    {
        return this.accountStatusUtil.getSimplifiedDescription(accountState);
    }
}